import { setText } from '../dom-helpers.js';

// 4.M reason discriminator (Codex iter 1 plan MINOR fix). The
// orchestrator emits `'walk-error'` with one of these reasons + the
// embed flag so the toast can render a context-appropriate message.
export type WalkErrorReason = 'pointer-lock-failed' | 'touch' | 'unsupported';

export interface WalkErrorToastOptions {
  reason: WalkErrorReason;
  embed: boolean;
  dismissMs?: number | undefined;
}

function messageFor(reason: WalkErrorReason, embed: boolean): string {
  switch (reason) {
    case 'touch':
      return 'Walk Mode richiede mouse + tastiera';
    case 'pointer-lock-failed':
      return embed
        ? 'Aggiungi allow="pointer-lock" all’iframe parent'
        : 'Pointer lock non disponibile in questo browser';
    case 'unsupported':
      return 'Walk Mode non supportato in questo browser';
  }
}

// Returns a manual cleanup so the renderer can dismiss any prior toast
// before showing a new one. Aria-live polite so AT announces without
// interrupting screen reader flow.
export function showWalkErrorToast(root: HTMLElement, opts: WalkErrorToastOptions): () => void {
  const dismissMs = opts.dismissMs ?? 4000;

  const toast = document.createElement('div');
  toast.classList.add('viewer-ui-interactive');
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  toast.style.cssText =
    'position:fixed;top:1rem;left:50%;transform:translateX(-50%);background:rgba(15,15,17,0.92);color:#fde68a;padding:0.5rem 0.875rem;border-radius:0.5rem;border:1px solid rgba(245,158,11,0.30);font-family:system-ui,sans-serif;font-size:0.8125rem;z-index:13;pointer-events:auto;max-width:24rem;text-align:center';
  setText(toast, messageFor(opts.reason, opts.embed));

  root.appendChild(toast);

  const timer = setTimeout(() => toast.remove(), dismissMs);

  return () => {
    clearTimeout(timer);
    toast.remove();
  };
}
